import config from '../config';
// Services
import StorageService from 'services/Storage.service';

let LEGACY_TOKEN:string | null = null;

const fetcher = async (path:string, args:RequestInit = {}) => {
  const nonce = StorageService.getNonce();
  const qwid = StorageService.getQwid();

  const params:any = {};
  if ( nonce ) params['x-qw-nonce'] = nonce;
  if ( qwid ) params['x-qw-id'] = qwid;
  if ( LEGACY_TOKEN ) params['Legacy-Token'] = LEGACY_TOKEN;

  if ( Object.keys(params).length ){
    args.headers = {
      ...args.headers,
      ...params
    }
  }

  const url = `${config.apiURL}${path}`;
  const request:RequestInfo = new Request(url, { ...args, credentials: 'include' });
  const response:Response = await fetch(request);

  try {
    const token = response.headers.get('Legacy-Token');
    if ( token ) LEGACY_TOKEN = token;
  } catch(err){}

  return response;
}

export default fetcher;
